import { Button, List, Popover, Tooltip, Typography } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { LeaveRequestDocument } from "../../utils/types";
import { formatRequestedAt } from "../../utils/helpers";

type ViewDocumentsBtnProps = {
  documents?: LeaveRequestDocument[];
};

// Shared "view uploaded documents" affordance - the creator (My Leave
// Requests) and the roles reviewing a request (Manager in All Leave
// Requests/the approval modal, Administrativ in Pending Administrativ
// Review) all need the same read access to what was uploaded (current
// version + full history by timestamp/filename), not just Administrativ's
// dedicated Blood Donation document-review flow.
export const ViewDocumentsBtn = ({ documents }: ViewDocumentsBtnProps) => {
  if (!documents?.length) return null;

  return (
    <Popover
      title="Uploaded documents"
      trigger="click"
      content={
        <List
          size="small"
          style={{ maxWidth: 320 }}
          dataSource={documents}
          renderItem={(doc) => (
            <List.Item>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <a href={doc.fileBase64} download={doc.fileName} target="_blank" rel="noreferrer">
                  {doc.fileName || "(no file name)"}
                </a>
                <Typography.Text type="secondary">
                  {formatRequestedAt(doc.uploadedAt)} - {doc.reviewStatus}
                </Typography.Text>
              </div>
            </List.Item>
          )}
        />
      }
    >
      <Tooltip title="View uploaded documents">
        <Button type="text" icon={<FileTextOutlined />} />
      </Tooltip>
    </Popover>
  );
};

export default ViewDocumentsBtn;
